/**
 * @prettier
 */

import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ButtonV2 } from '@zola/zola-ui';
import { getOrders, getOrdersBusy } from 'cards/selectors/ordersSelector';
import { fetchOrders as fetchOrdersAction } from 'cards/actions/ordersActions';
import { fetchProject as fetchProjectAction } from 'cards/actions/projectActions';
import Loader from 'components/common/ui/Loader';
import Layout from '../Layout/Layout';
import SampleOrderTile from './SampleOrderTile';
import styles from './styles.module.less';

export const SampleLimitviewBase = ({
  orders,
  fetchOrders,
  fetchProject,
  busy,
  closeModal,
  setModalOptions,
}) => {
  const [orderData, setOrderData] = useState(null);
  const [ordersFetched, setOrdersFetched] = useState(false);

  useEffect(() => {
    setModalOptions({ preventClose: false, hideClose: false });

    fetchOrders().then(() => setOrdersFetched(true));
  }, []);

  useEffect(() => {
    if (!busy && orders && ordersFetched) {
      Promise.all(
        orders.map(order => {
          if (order.projects[0]) {
            return fetchProject(order.projects[0]).then(project => ({ order, project }));
          }

          return Promise.resolve(null);
        })
      ).then(setOrderData);
    }
  }, [busy, orders, ordersFetched]);

  if (busy || !ordersFetched || orderData === null) {
    return <Loader />;
  }

  return (
    <div className={styles.box}>
      <Layout.Header>You&#39;re On a Roll</Layout.Header>
      <div className={styles.textBox}>
        <Layout.Text>
          Looks like you’ve ordered the max number of samples. Love a design you tried? Place a full
          order anytime (and get a printed proof before you buy!).
        </Layout.Text>
      </div>
      <div className={styles.orderListingBox}>
        {orderData.map(
          (data, i) =>
            data && (
              <SampleOrderTile
                key={`${data.project.uuid[0]}--${i}`}
                order={data.order}
                project={data.project}
              />
            )
        )}
      </div>
      <div className={styles.backButtonBox}>
        <ButtonV2 onClick={closeModal}>Go Back</ButtonV2>
      </div>
    </div>
  );
};

export const mapStatetoProps = state => ({
  busy: getOrdersBusy(state),
  orders: getOrders(state),
});

export const mapDispatchToProps = dispatch => ({
  fetchOrders: () => dispatch(fetchOrdersAction()),
  fetchProject: projectUUID => dispatch(fetchProjectAction(projectUUID)),
});

export default connect(mapStatetoProps, mapDispatchToProps)(SampleLimitviewBase);



// WEBPACK FOOTER //
// ./src/cards/components/common/SingleSample/SampleLimitView/SampleLimitView.jsx